<template>
  <div>
    <div class="table-div">
      <el-table :data="installApps" border stripe>
        <el-table-column prop="appName" :label="$t('message.appName')" />
        <el-table-column prop="packageName" :label="$t('message.packageName')"/>
        <el-table-column prop="version" :label="$t('message.version')" width="180"/>
        <el-table-column prop="installTime" :label="$t('message.installTime')" width="180" />
      </el-table>
    </div>

  </div>
</template>

<script>
    export default {
        name: "TerminalEditApp",

        props: {
          installApps:{
            required: true
          },
          lastDiagnosticTime: {
            required: true
          }
        }
    }
</script>

<style scoped>
  .table-div {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/terminal/TerminalEditApp.vue